'use client';

import React, { FC, useContext } from 'react';
import Link, { LinkProps } from 'next/link';
import { GlobalSourcePageTrackerContext } from '@/context/sourcePageTracker/sourcePageTrackerProvider';

interface StatefulLinkProps extends LinkProps, React.AnchorHTMLAttributes<HTMLAnchorElement> {
    state?: Record<string, any> | null;
}

const StatefulLink: FC<StatefulLinkProps> = ({ children, state, ...props }) => {
    const { setCurrentSourcePageDataRef } = useContext(GlobalSourcePageTrackerContext);

    return (
        <Link
            onClick={() => {
                try {
                    setCurrentSourcePageDataRef(state);
                } catch (err) {
                    console.log('err: ', err);
                }
            }}
            {...props}>
            {children}
        </Link>
    );
};

export default StatefulLink;
